<div class="header">
  <div class="typeContainer">
    <ng-container [ngSwitch]="nodeType"><ng-container *ngSwitchCase="'menu'"><div class="menu-title-container"><div class="typeImage" [ngStyle]="{'background': 'url(' + nodeIcons[typeName]?.image.primary + ') no-repeat center/100%'}"></div><div class="title-container"><span class="typeName">{{ nodeIcons[typeName].title }}</span><span class="typeDescription"> User-Facing Interaction </span></div></div></ng-container><ng-container *ngSwitchCase="'action'"><div class="menu-title-container"><ng-container *ngTemplateOutlet="icons; context: {icon: nodeIcons[typeName]?.image.primary, nodeType: typeName}"></ng-container><div class="title-container"><span class="typeName">{{ nodeIcons[typeName].title }}</span><span class="typeDescription"> Action </span></div></div></ng-container><ng-container *ngSwitchCase="'integration'"><div class="menu-title-container"><ng-container *ngTemplateOutlet="icons; context: {icon: nodeIcons[typeName]?.image.primary, nodeType: typeName}"></ng-container><div class="title-container"><span class="typeName">{{ nodeIcons[typeName].title }}</span><span class="typeDescription"> Integration </span></div></div></ng-container></ng-container>
  </div>

  <div class="node-number-container">
    <p class="number-text">
      {{stepNumber}}
    </p>
  </div>
</div>

<ng-template #chat2payError>
    <div class="chat2pay">
        <div class="chat2pay-Icon">
            <img src='../../../../../assets/svg/redesign/chat2pay-error-ico.svg'>
        </div>
        <div class="chat2pay-ConfigMessage">
            Chat 2 Pay needs to be configured in the Clickatell Portal first in order to use in Chat Flow
        </div>
        <a class="portal_link" href="https://app.clickatell.com" target="_blank">
        <div class="chat2pay-Redirect">
            Go to Clickatell Portal
        </div>
        </a>
    </div>

</ng-template>

<div id="formBody" class="form_body" [ngClass]="isTrackNodeOverlayOpen ? '' : 'auto-scroll-y'">
  <ng-template [ngIf]="show && paths.length > 0">
    <mat-accordion class="groups" [multi]="true">
      <ng-container *ngFor="let group of groups">
        <div [class]="setGroupClass(group)">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ objectKeys(group) }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="groups-data-container">
              <ng-container *ngFor="let path of group[objectKeys(group)]">
                <ng-container
                        *ngTemplateOutlet="
                  getFormControlName(path) !== '#' && getFormControlName(path) !== '$'
                    ? field
                    : options;
                  context: {
                    controlName: getFormControlName(path),
                    groupName: getFormGroupParent(path),
                    path: path
                  }
                "
                  >
                  </ng-container>
                </ng-container>
              </div>
          </mat-expansion-panel>
        </div>
      </ng-container>
    </mat-accordion>
  </ng-template>

  <ng-template #field let-groupName="groupName" let-controlName="controlName" let-path="path">
    <ng-container
      *ngTemplateOutlet="
        dynamicFields;
        context: {
          myField: layout[controlName],
          myForm: groupName,
          myControlName: controlName,
          myPath: path,
          id: controlName
        }
      "
    >
    </ng-container>
  </ng-template>

  <ng-template #options let-groupName="groupName" let-path="path">
    @if (getFormControlName(path) !== '$') {
      @switch (layout[getName(getPath(path))]?.dataType) {
        @case ('keyValue') {
          <div class="resultInputContainer">
            <ng-container
              *ngTemplateOutlet="keyValue; context: { path: getPath(path) }"
            ></ng-container>
          </div>
        }
        @case ('keyObject') {
          <ng-container
            *ngTemplateOutlet="keyObject; context: { path: getPath(path) }"
          ></ng-container>
        }
        @case ('array') {
          <ng-container *ngTemplateOutlet="array; context: { path: getPath(path) }"></ng-container>
        }
        @case ('item') {
          <div
            *ngIf="
              getAttributeValue(getFormControlOptionsName(path), ADD_ATTRIBUTE) && canEditState
            "
            class="add-new-item-block"
          >
            <div class="addBtnContainer" (click)="addOption(path, 'items', '#')">
              <span class="addIcon">
                <img class="action-img" src='../../../../../assets/svg/addIcon.svg' />
              </span>
              <span class="addLabel"> Add New {{ layout[getName(path)]?.label }} </span>
            </div>
            <div
              class="collapse-expand-btn"
              [ngClass]="{ collapsed: collapsed }"
              (click)="collapseExpandLogicItems()"
              [matTooltip]="getCollapseTooltip()"
              matTooltipPosition="left"
              matTooltipHideDelay="200"
              matTooltipClass="left-tooltip"
            ></div>
          </div>
          <ng-container *ngTemplateOutlet="item; context: { path: getPath(path) }"></ng-container>
        }
        @default { Missing Data type }
      }
    }
  </ng-template>

  <ng-template #item let-path="path">
    <mat-accordion
      class="result-logic-list"
      [multi]="true"
      cdkDropList
      (cdkDropListDropped)="drop(path, $event)"
      #LogicAccordion="matAccordion"
    >
      <mat-expansion-panel
        cdkDrag
        [cdkDragDisabled]="canDrop()"
        [expanded]="true"
        *ngFor="let item of getViewData(path); trackBy: trackByItem; let index = index"
        class="result-logic-item"
        [ngStyle]="{ margin: '10px 0' }"
      >
        <div class="custom-placeholder" *cdkDragPlaceholder></div>
        <div *cdkDragPreview class="result-logic-item-header" [ngClass]="{'warning': warningCondition && (index +1) > channelDisplayType}">
          <div class="result-logic-item-header-info">
            <div class="title-text">{{ index + 1 }}{{ getLogicItemTitle(index + 1) }}</div>
            <div class="title-btns-block">
              <div class="move-btn"></div>
              <div
                class="remove-btn"
                *ngIf="getAttributeValue(getName(path), DELETE_ATTRIBUTE) && canEditState"
              ></div>
            </div>
          </div>
        </div>
        <mat-expansion-panel-header class="result-logic-item-header" [ngClass]="{'warning': warningCondition && (index +1) > channelDisplayType}">
          <div class='tooltip' [matTooltip]="toolTipText" [matTooltipPosition]="'above'"></div>
          <mat-panel-title>
            <ng-container>
              <div class="result-logic-item-header-info">
                <div class="title-text">{{ index + 1 }}{{ getLogicItemTitle(index + 1) }}</div>
                <div class="title-btns-block">
                  <div class="move-btn"></div>
                  <div
                    class="remove-btn"
                    *ngIf="getAttributeValue(getName(path), DELETE_ATTRIBUTE) && canEditState"
                    (click)="removeFormControl(path, getName(path), index)"
                  ></div>
                </div>
              </div>
            </ng-container>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngFor="let itemOptions of itemToPath(item); let i = index">
          <ng-template [ngIf]="checkItemOptions(itemOptions)" [ngIfElse]="addKeyword">
            <ng-component
              *ngTemplateOutlet="
                dynamicFields;
                context: {
                  id: 'item-' + itemOptions + '-' + (index + 1) + '_' + i,
                  myField: itemOptions === 'bodyText' ? layout['description'] : layout[itemOptions],
                  myForm: getOptionFormGroup(['menu', 'options', 'items'], item.key),
                  myControlName: itemOptions,
                  myPath: createPath(['menu', 'options', 'items'], item.key) + '.' + itemOptions,
                  myIndex: item.key
                }
              "
            >
            </ng-component>
          </ng-template>
          <ng-template #addKeyword>
            <ng-component
              *ngTemplateOutlet="
                dynamicFields;
                context: {
                  id: 'item-' + itemOptions + '-' + (index + 1),
                  myField: layout[itemOptions],
                  myForm: getOptionFormGroup(['menu', 'options', 'keywords'], ''),
                  myControlName: item.key,
                  myIndex: item.key,
                  myPath: createPath(['menu', 'options', itemOptions]) + '.' + item.key
                }
              "
            >
            </ng-component>
          </ng-template>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-template>

  <ng-template #keyObject let-path="path">
    <div [formGroup]="getFormGroupParent(createPath(path))">
      <div
        *ngIf="
          getAttributeValue(getName(path), ADD_ATTRIBUTE) && canEditState;
          else keyObjectNoBtn
        "
      >
        <ng-component *ngTemplateOutlet="addKeyObjectBtn; context: { path: path }"> </ng-component>
      </div>

      <ng-template #keyObjectNoBtn>
        <div class="keyObjectNoBtn"></div>
      </ng-template>

      <div [formArrayName]="getName(path)">
        <div
          *ngFor="let actionParam of getFormArrayValue(path); let i = index; trackBy: trackByItem"
        >
          <ng-container
            *ngIf="getAttributeValue(getName(path), DELETE_ATTRIBUTE) && canEditState"
          >
            <ng-component
              *ngTemplateOutlet="
                formArrayDeleteBtn;
                context: {
                  path: path,
                  controlName: getName(path),
                  myClass: 'logicDeleteButton',
                  index: i
                }
              "
            >
            </ng-component>
          </ng-container>
          <ng-container [formGroupName]="i">
            <div [id]="'keyObject-' + (i + 1)" class="keyObjectContainer">
              <label
                class="keyValuePairLabel"
                *ngIf="layout[getName(path)] && layout[getName(path)]?.label"
              >
                {{ layout[getName(path)]?.label }}
              </label>
              <div class="">
                <ng-component
                  *ngTemplateOutlet="
                    dynamicFields;
                    context: {
                      id: 'keyObject-key' + getName(path) + '-' + (i + 1),
                      myField: layout[getName(path)]?.key,
                      myForm: getFromArrayGroup(createPath(path, i.toString())),
                      myControlName: 'key',
                      myClass: '',
                      myPath: path
                    }
                  "
                >
                </ng-component>
                <div *ngFor="let object of actionParam.object | keyvalue; trackBy: trackByItem">
                  <ng-component
                    *ngTemplateOutlet="
                      dynamicFields;
                      context: {
                        id: 'keyObject-' + getName(path) + object.key + '-' + (i + 1),
                        myField: layout[getName(path)]?.value[object.key],
                        myForm: getFromArrayGroup(createPath(path, i.toString() + '.' + 'object')),
                        myControlName: object.key,
                        myClass: '',
                        myPath: path
                      }
                    "
                  >
                  </ng-component>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #keyValue let-path="path">
    <div [formGroup]="getFormGroupParent(createPath(path))">
      <div
        *ngIf="
          getAttributeValue(getName(path), ADD_ATTRIBUTE) && canEditState;
          else keyValueNoBtn
        "
      >
        <ng-component *ngTemplateOutlet="addKeyValueBtn; context: { path: path }"> </ng-component>
      </div>

      <ng-template #keyValueNoBtn>
        <div class="keyValueNoBtn"></div>
      </ng-template>

      <div [formArrayName]="getName(path)">
        <div
          *ngFor="let actionParam of getFormArrayValue(path); let i = index; trackBy: trackByItem"
        >
          <ng-container [formGroupName]="i">
            <div
              [ngClass]="[
                'keyValuePairContainer',
                getLayoutActionType() +
                  ' ' +
                  layout[getName(path)]?.label?.split(' ').join('_').toLowerCase()
              ]"
            >
              <!-- [ngClass]='{getAttributeValue(getName(path),ADD_ATTRIBUTE)?getAttributeValue(getName(path),ADD_ATTRIBUTE):"keyValuePairColumn"}' -->
              <!-- , 'keyValuePairColumn': !getAttributeValue(getName(path),ADD_ATTRIBUTE) -->
              <div
                class="keyValuePair"
                [ngClass]="
                  getAttributeValue(getName(path), 'class')
                    ? getAttributeValue(getName(path), 'class')
                    : 'keyValuePairColumn'
                "
              >
                <label class="keyValuePairLabel" *ngIf="layout[getName(path)]?.label">{{
                  layout[getName(path)]?.label
                }}</label>
                <app-cms *ngIf="layout[getName(path)]?.label === 'Filter By'" class="popover" [cmsData]="buildCMSConditions('nodeBuilder', 'filterBy', null, '17')"></app-cms>
                <app-cms *ngIf="layout[getName(path)]?.label === 'Exclude'" class="popover" [cmsData]="buildCMSConditions('nodeBuilder', 'exclude', null, '17')"></app-cms>
                <ng-container
                  *ngIf="getAttributeValue(getName(path), DELETE_ATTRIBUTE) && canEditState; else NoKeyValueDeleteButton"
                >
                  <ng-component
                    *ngTemplateOutlet="
                      formArrayDeleteBtn;
                      context: {
                        path: path,
                        controlName: getName(path),
                        myClass: 'keyValueDeleteButton',
                        index: i
                      }
                    "
                  >
                  </ng-component>
                </ng-container>
                <ng-template #NoKeyValueDeleteButton>
                  <div *ngIf="typeName === 'httpCall'" class="NoKeyValueDeleteButton">
                  </div>
                </ng-template>
                <div class="keyValueInputContainer" *ngIf="layout[getName(path)]?.label !== 'Filter By' && layout[getName(path)]?.label !== 'Exclude'">
                  <div class="keyValueInputBox">
                    <ng-component
                      *ngTemplateOutlet="
                        dynamicFields;
                        context: {
                          id: 'keyValue-key-' + (i + 1) + '_' + getName(path),
                          myField: layout[getName(path)]?.key,
                          myForm: getFromArrayGroup(createPath(path, i.toString())),
                          myControlName: 'key',
                          myClass: 'keyValuePairKey',
                          myPath: createPath(path) + '.' + i + '.key',
                          myIndex: i + 1
                        }
                      "
                    >
                    </ng-component>
                  </div>
                  <div class="keyValueInputBox">
                    <ng-component
                      *ngTemplateOutlet="
                        dynamicFields;
                        context: {
                          id: 'keyValue-value-' + (i + 1) + '_' + getName(path),
                          myField: layout[getName(path)]?.value,
                          myForm: getFromArrayGroup(createPath(path, i.toString())),
                          myControlName: 'value',
                          myClass: 'keyValuePairValue',
                          myPath: createPath(path) + '.' + i + '.value'
                        }
                      "
                    >
                    </ng-component>
                  </div>
                </div>
                <div class="keyValueInputContainer" *ngIf="layout[getName(path)]?.label === 'Filter By' || layout[getName(path)]?.label === 'Exclude'">
                  <div class="keyValueInputBox">
                    <ng-component
                      *ngTemplateOutlet="
                        dynamicFields;
                        context: {
                          id: 'keyValue-key-' + (i + 1) + '_' + getName(path),
                          myField: layout[getName(path)]?.key,
                          myForm: getFromArrayGroup(createPath(path, i.toString())),
                          myControlName: 'key',
                          myClass: 'keyValuePairKey',
                          myPath: createPath(path) + '.' + i + '.key',
                          myIndex: i + 1
                        }
                      "
                    >
                    </ng-component>
                  </div>
                </div>
                <div class="keyValueInputContainer" *ngIf="layout[getName(path)]?.label === 'Filter By' || layout[getName(path)]?.label === 'Exclude'">
                  <div class="keyValueInputBox">
                    <ng-component
                      *ngTemplateOutlet="
                        dynamicFields;
                        context: {
                          id: 'keyValue-value-' + (i + 1) + '_' + getName(path),
                          myField: layout[getName(path)]?.value,
                          myForm: getFromArrayGroup(createPath(path, i.toString())),
                          myControlName: 'value',
                          myClass: 'keyValuePairValue margin-top-5',
                          myPath: createPath(path) + '.' + i + '.value'
                        }
                      "
                    >
                    </ng-component>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

    <ng-template #array let-path="path">
        <div [formGroup]="getFormGroupParent(createPath(path))">
            <div [formArrayName]="getName(path)">
                <div class="label-block">
                    <label [id]="getName(path)+'-header'" class="form-control-label">
                        {{layout[getName(path)].attributes['header']}}
                    </label>
                </div>
                <div *ngFor="let arrayItem of getData(path); let i = index; trackBy: trackByItem ">
                    <ng-component *ngTemplateOutlet="dynamicFields;
                        context: {
                            id: getData(path) +'-array-value-'  + (i + 1),
                            myField: layout[getName(path)],
                            myForm: getFormGroupParent(createPath(path, i.toString())),
                            myControlName: i,
                            myPath: path}">
                    </ng-component>
                </div>
            </div>
            <div *ngIf="getAttributeValue(getName(path),ADD_ATTRIBUTE) && canEditState">
                <ng-component *ngTemplateOutlet="addValueBtn; context: {path: path}">
                </ng-component>
            </div>
        </div>
    </ng-template>

  <ng-template
    #dynamicFields
    let-field="myField"
    let-myForm="myForm"
    let-myControlName="myControlName"
    let-myPath="myPath"
    let-myIndex="myIndex"
    let-myClass="myClass"
    let-id="id"
  >
    <ng-template [ngIf]="field?.label" [ngIfElse]="noLable">
      <div class="from-control-container">
        <label [id]="id + '-label'" class="col-md-3 fieldLabel form-control-label" [attr.for]="id">
          <span *ngIf="field?.label?.length > 0">
            @switch (field.label) {
              @case ('$') {
                <div class='label-block'>
                  <label class="form-control-label">{{field?.text}} {{ myIndex }}:</label>
                  <label *ngIf="field?.attributes?.optional" class="fieldLabel form-control-label-optional" >Optional</label>
                </div>
              }
              @case ('#') { Result{{ myIndex }}: }
              @case ('*') {}
              @case ('Mandatory Authentication') {
                <div *ngIf="!isAuthProviderPresent" >
                  {{ field?.attributes?.labels ? getLabel(field.attributes.labels) : field.label }}:
                </div>
              }
              @default {
                <ng-template [ngIf]="field.label === 'Amount' && checkCurrencyTypeValue() === 'predefined'"
                 [ngIfElse]="defaultLabel">
                    Amount Incl. Tax
                </ng-template>
                <ng-template #defaultLabel>
                  <div class='label-block'>
                    {{ field?.attributes?.labels ? getLabel(field.attributes.labels) : field.label }}
                    <ng-container *ngIf="field.label === 'Channel Display Type (Default)'">
                      <app-cms class="popover" [cmsData]="buildCMSConditions('nodeBuild', 'displayType', null, '17')"></app-cms>
                    </ng-container>
                    <label *ngIf="field?.attributes?.optional" class="fieldLabel form-control-label-optional" >Optional</label>
                  </div>
                </ng-template>
              }
            }
          </span>
        </label>
        <label *ngIf="field?.attributes?.required" class="fieldLabel form-control-label-required">Required</label>
      </div>
    </ng-template>
    <ng-template #noLable>
      <ng-template [ngIf]="field?.label?.length === 0" [ngIfElse]="noLableFound"> </ng-template>
      <ng-template #noLableFound>
        {{ myControlName }}
      </ng-template>
    </ng-template>

    <div *ngIf="checkErrors(myPath) && !checkMediaNodeSandbox(myControlName)" class="error-block">
      <ng-container
        *ngTemplateOutlet="
          validators;
          context: { errors: myDynamicForm?.get(myPath).errors, myControlName: myControlName }
        "
      >
      </ng-container>
    </div>

    <ng-container [formGroup]="myForm">
      <ng-container [ngSwitch]="getType(field)">
        <label *ngSwitchCase="'label'" class="col-md-3 form-control-label">{{
          myForm.get(myControlName).value
        }}</label>

        <!-- [ngClass]="myClass ? myClass : 'dynamicInput'"

                [ngClass]="{myClass: myClass, 'dynamicInput': !myClass, 'inputDisabled': isDisabled(myPath)}" -->
        <input
          #input
          class="dynamicField"
          [ngClass]="[
            isDisabled(myPath) ? 'inputDisabled' : '',
            !myClass ? 'dynamicInput' : myClass
          ]"
          *ngSwitchCase="'text'"
          [attr.type]="field.type"
          [id]="id"
          [name]="myControlName"
          [formControlName]="myControlName"
          (focus)="focusFunction($event, field.label, myPath)"
          (blur)="blurFunction($event)"
          [placeholder]="field?.placeholder ? field?.placeholder : ''"
          [disabled]="field?.attributes?.readonly ? field?.attributes?.readonly : null"
          [readonly]="isResultFieldReadOnly(myPath)"
          [maxlength]="field?.validators?.maxLength ? field?.validators?.maxLength : ''"
        />

        <div *ngSwitchCase="'image'">
          <input class="dynamicInput dynamicField"
            [formControlName]="myControlName"
            [id]="id"
            type="hidden"
          />
          <select-media [image]="getImageRef(myForm.get(myControlName).value)" [imageOnly]="false" [menuHeader]="true"
            (setImageRef)="setImageRef($event, myForm.get(myControlName))">
          </select-media>
        </div>

        <div *ngSwitchCase="'asset'">
          <div *ngIf="checkMediaDirectionValue() === 'outbound'; else inbound">
            <label
              [id]="id + '-label'"
              class="col-md-3 fieldLabel form-control-label"
              [attr.for]="id"
              >Source:</label
            >
            <div class="switch-media-container">
              <div class="switch-media-block">
                <mat-button-toggle-group
                  [value]="getMediaValueType()"
                  [disabled]="!canEditState"
                  class="toggle-media-type-group"
                  hideSingleSelectionIndicator
                >
                  <mat-button-toggle (change)="toggleChange($event.value)" value="API"
                    >API</mat-button-toggle
                  >
                  <mat-button-toggle (change)="toggleChange($event.value)" value="Assets"
                    >Assets</mat-button-toggle
                  >
                </mat-button-toggle-group>
              </div>
            </div>

            <div class="select-asset-container" *ngIf="mediaValueType === 'Assets'; else inbound">
              <div
                *ngIf="checkErrors(myPath) && checkMediaNodeSandbox(myControlName)"
                class="error-block"
              >
                <ng-container
                  *ngTemplateOutlet="
                    validators;
                    context: {
                      errors: myDynamicForm?.get(myPath).errors,
                      myControlName: 'Variable'
                    }
                  "
                >
                </ng-container>
              </div>
              <select-media
                [image]="myForm.get(myControlName).value"
                [imageOnly]="false"
                (setImageRef)="setImageRef($event, myForm.get(myControlName))"
              >
              </select-media>
              <input
                class="dynamicInput dynamicField"
                [formControlName]="myControlName"
                [id]="id"
                type="hidden"
              />
            </div>
          </div>

          <ng-template #inbound>
            <label class="fieldLabel form-control-label">Variable:</label>
            <div *ngIf="checkErrors(myPath) && checkMediaNodeSandbox(myControlName)" class="error-block">
              <ng-container
                      *ngTemplateOutlet="validators; context: { errors: myDynamicForm?.get(myPath).errors, myControlName: 'Variable'}">
              </ng-container>
            </div>
            <input class="dynamicInput dynamicField"
                   [formControlName]="myControlName"
                   [id]="id"
                   [ngClass]="{'inputDisabled': isDisabled(myPath)}"
                   (focus)="focusFunction($event, field.label, myPath)"
                   (blur)="blurFunction($event)">
          </ng-template>
        </div>

                <div *ngSwitchCase="'actionType'">
                  <action-type
                          [disabled]="isAuthProviderPresent"
                          [buttonsData]="field?.attributes?.buttons"
                          (change)="selectedActionType = $event; formValueChange($event, 'authType', myPath)"
                          [selectedValue]="selectedActionType"
                  >
                  </action-type>
                </div>

                <div *ngSwitchCase="'number'" [ngStyle]="{position: 'relative'}" [ngClass]="{'field-with-symbol': field?.attributes?.symbol}">
                    <div class="symbol-div">
                        <input #number type="number"
                           class="dynamicField"
                           [ngClass]="[isDisabled(myPath) ? 'inputDisabled': '' , !myClass ? 'dynamicInput' : myClass]"
                           [attr.type]="field.type" [id]="id" [name]="myControlName"
                           [formControlName]="myControlName" (focus)="focusFunction($event, field.label, myPath)"
                           (blur)="blurFunction()" [placeholder]="field?.placeholder ? field?.placeholder : ''"
                           [disabled]="field?.attributes?.readonly ? field?.attributes?.readonly : null">

            <div class="symbol" *ngIf="field?.attributes?.symbol">
                {{ field?.attributes?.symbol }}
            </div>
          </div>
        </div>

                <!-- we don't need it if we using the click (blur)="blurFunction($event, field.label)"-->
                <textarea #textArea class="dynamicTextArea dynamicField" [ngClass]="{'inputDisabled': isDisabled(myPath)}"
                    *ngSwitchCase="'textarea'" [attr.type]="field.type" [id]="id" [name]="myControlName"
                    [formControlName]="myControlName" [placeholder]="field?.placeholder ? field?.placeholder : ''"
                    [disabled]="field?.attributes?.readonly ? field?.attributes?.readonly : null"
                    (focus)="focusFunction($event, field.label, myPath)"
                    (blur)="blurFunction()"></textarea>
                <!-- we don't need it if we using the click (blur)="blurFunction($event, field.label)"-->
        <div  *ngSwitchCase="'checkbox-single'">
          <mat-slide-toggle
                  *ngIf="!isAuthProviderPresent ||this.typeName !='authenticate'"
                  #toggle
                  [color]="'primary'"
                  [id]="id"
                  class="dynamicToggle"
                  [name]="myControlName"
                  [formControlName]="myControlName"
                  (change)="toggleCheckHandler($event, id)">
          </mat-slide-toggle>
        </div>

        <ng-container *ngIf="showNextSelector">
          <div [class]="field?.attributes?.class ? field?.attributes?.class : ''">
<!--            (openFlowStepSelectionModal)="openFlowStepSelectionModal($event, myForm)"-->
            <next-selector
            *ngSwitchCase="'next'"
            [selectorType]="'both'"
            [flowSteps]="currentSteps"
            [flows]="flows"
            [name]="myControlName"
            [canEditFlows]="canEditState"
            [form]="myForm"
            (onNextStepError)="onErrorTriggered($event)"
            ></next-selector>
          </div>

          <div [class]="field?.attributes?.class ? field?.attributes?.class : ''" style="padding-bottom:20px">
            <!--            (openFlowStepSelectionModal)="openFlowStepSelectionModal($event, myForm)"-->
            <next-selector
                    *ngSwitchCase="'default'"
                    [selectorType]="'both'"
                    [flowSteps]="currentSteps"
                    [flows]="flows"
                    [name]="'next'"
                    [canEditFlows]="canEditState"
                    [form]="myForm.controls['default']"
                    (onNextStepError)="onErrorTriggered($event)"
                    [isOptional]="true"
            ></next-selector>
          </div>
        </ng-container>

        <!-- [readonly]="isDisabled(myPath)" -->
        <div *ngSwitchCase="'chips'">
          <clickatell-chip
            #chips
            [id]="id"
            [readonly]="!canEditState"
            [field]="field"
            [name]="myControlName"
            [path]="myPath"
            [parentFormGroup]="myForm"
            [form]="myForm"
            [index]="myIndex"
          >
          </clickatell-chip>
        </div>

        <div *ngSwitchCase="'dropdown'">
          <mat-select
                  *ngIf="!selected; else chat2PayDropDown"
                  [ngClass]="{dynamicDropdown: true, 'dynamicDropdownDisabled': isDisabled(myPath)}" #dropdown
                  [id]="id"
                  [placeholder]="field.placeholder"
                  [formControlName]="myControlName"
                  (selectionChange)="formValueChange(dropdown.value, myControlName, myPath)">
            <mat-option *ngFor="let option of field?.attributes?.options | keyvalue" [value]="option.key">
              {{option.value}}
            </mat-option>
          </mat-select>

          <div class="banner-container" *ngIf="field?.attributes?.warning && checkOptionsMaxLengthInvalid()">
              <div class="banner-block">
                  <div class="icon"></div>
                  <div class="content">
                      You have {{ currentIndex }} logic options. {{ getWhatsAppDisplayType()}} menus can only support up to {{ checkOptionsMaxLength() }}. Additional options will not be displayed.
                      <a class="banner-link" target="_blank" href="https://clickatell.gitbook.io/flow/">
                          Read more.
                      </a>
                  </div>
              </div>
          </div>

          <ng-template #chat2PayDropDown>
            <mat-select
                  [ngClass]="{dynamicDropdown: true, 'dynamicDropdownDisabled': isDisabled(myPath)}" #dropdown
                  [id]="id"
                  [formControlName]="myControlName"
                  [placeholder]="field.placeholder"
                  (selectionChange)="formValueChange(dropdown.value, myControlName, myPath)">
              <mat-option *ngFor="let option of field?.attributes?.options | keyvalue" [value]="option.key">
                {{option.value}}
              </mat-option>
            </mat-select>
          </ng-template>
        </div>
        <div *ngSwitchCase="'button'">
            <display-type-btn (change)="displayChange($event)" [data]="displayTypeModalData" [optionLength]="currentIndex"></display-type-btn>
        </div>

        <div *ngSwitchCase="'searchable-dropdown'" >
            <div class="money-types-autocomplete-block" *ngIf="checkCurrencyTypeValue() === 'predefined'; else inputAmount">
                <div class="money-types-autocomplete-input-block">
                    <div class="selected-money-symbol">{{ selectedMoneyType?.symbol }}</div>
                    <input class="dynamicInput dynamicField"
                        type="text"
                        [formControlName]="myControlName"
                        [id]="id"
                        [ngClass]="{'inputDisabled': isDisabled(myPath)}"
                        (focus)="focusFunction($event, field.label, myPath)"
                        [placeholder]="field.placeholder"
                        (blur)="blurFunction($event)">

                    <div class="selected-money-type" [ngClass]="{active: activeSearchMoneyTypes}" (click)="setActiveSearchMoneyTypes()">{{ selectedMoneyType?.iso }}</div>
                </div>
                <div class="money-types-autocomplete-search-block"
                     *ngIf="activeSearchMoneyTypes"
                     matAutocompleteOrigin
                     #origin="matAutocompleteOrigin">
                    <div class="close" (click)="clearSearchForm()"></div>
                    <form>
                        <input class="search"
                            type="text"
                            #searchMoneyType
                            placeholder="Search country or symbol"
                            [matAutocomplete]="auto"
                            [formControl]="searchControl"
                            (blur)="blurSearchMoneyType()"
                            [matAutocompleteConnectedTo]="origin">

                        <mat-autocomplete class="chat2pay-autocomplete" autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setActiveMoneyType($event.option.value, field?.attributes?.setValue)">
                            <mat-option  class="chat2pay-autocomplete-option" *ngFor="let option of filteredOptions" [value]="option.name">
                                {{option.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </form>
                </div>
            </div>

            <ng-template #inputAmount>
                <input class="dynamicInput dynamicField"
                       type="text"
                       [formControlName]="myControlName"
                       [id]="id"
                       [ngClass]="{'inputDisabled': isDisabled(myPath)}"
                       (focus)="focusFunction($event, field.label, myPath)"
                       (blur)="blurFunction($event)">
            </ng-template>
        </div>

        <mat-select class="dynamicDropdown" *ngSwitchCase="'dropdownGroup'" #dropdownGroup [id]="id"
            [formControlName]="myControlName"
            [placeholder]="field.placeholder"
            (selectionChange)="dropdownGroupChange(dropdownGroup, myControlName, myPath)">
            <mat-optgroup *ngFor="let optionGroupName of field?.attributes?.optionsGroup | keyvalue"
                [label]="optionGroupName.key">
                <mat-option *ngFor="let option of optionGroupName.value | keyvalue; let id = index"
                    [id]="optionGroupName.key" [value]="option.key"> {{option.value}}
                </mat-option>
            </mat-optgroup>
        </mat-select>

        <div *ngSwitchCase="'dropdownApi'">
          <mat-select
            class="dynamicDropdown"
            #dropdownApi
            [id]="id"
            [formControlName]="myControlName"
            [placeholder]="field.placeholder"
            (selectionChange)="dropdownApiData(dropdownApi.value, myControlName, myPath)"
          >
            <mat-option *ngFor="let option of optionData$ | async | keyvalue" [value]="option.key">
              {{ option.key }}
            </mat-option>
          </mat-select>
          <div class="apiDetails" *ngFor="let apiDetail of apiDetails | keyvalue">
              <ng-container *ngIf="apiDetail.key !== 'headers'; else apiHeaders">
                  {{ apiDetail.key }} : {{ apiDetail.value }}
              </ng-container>
              <ng-template #apiHeaders>
                  Headers:
                  <ng-container *ngFor="let header of apiDetail.value | keyvalue">
                      <div>
                          {{ header.key }} : {{ header.value }}
                      </div>
                  </ng-container>
              </ng-template>
          </div>
        </div>
        <div *ngSwitchCase="'autocomplete'">
          <mat-select
            #autocomplete
            [ngClass]="{ dynamicDropdown: true, dynamicDropdownDisabled: isDisabled(myPath) }"
            type="text"
            [id]="id"
            [formControlName]="myControlName"
          >
            <div class="customSeparator_content">
              <input
                #inputSeparator
                class="customSeparator_input"
                type="text"
                placeholder="Add custom separator"
                (keydown.space)="onSpaceKeyDown($event)"
                (keydown.enter)="
                  onEnterKeyDown($event, inputSeparator.value, field?.attributes?.options, myPath);
                  inputSeparator.value = ''
                "
              />
              <button
                class="customSeparator_btn"
                (click)="
                  addSeparator(inputSeparator.value, field?.attributes?.options, myPath);
                  inputSeparator.value = ''
                "
              ></button>
            </div>
            <mat-option
              *ngFor="let option of getAutocompleteOptions(field?.attributes?.options)"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-select>
        </div>

        <div *ngSwitchCase="'selector'">
            <div [ngClass]="checkCurrencyTypeValue() === 'variable' || checkCurrencyTypeValue() === 'predefined' ? 'selectorGroupCurrency' : 'selectorGroup'">
                <mat-button-toggle-group (change)="formValueChange(group.value, myControlName, myPath)"
                    #group="matButtonToggleGroup" [value]="group.value" multiple="false"
                    [formControlName]="myControlName" hideSingleSelectionIndicator>
                    <mat-button-toggle class="selector-button"
                        *ngFor="let options of field?.attributes?.options | keyvalue" [value]="options.key">
                        {{options.value}}</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>


                <div *ngSwitchCase="'hidden'">
                    <input type="hidden"
                           [formControlName]="myControlName"
                           [id]="id">
                </div>


                <div *ngSwitchCase="'text-with-key'">
                    <input class="dynamicInput dynamicField inputDisabled" disabled="disabled" [value]="getKeyTextValue(myPath)">

                    <div class="label-block">
                        <label class="form-control-label">{{ field?.attributes?.valueLabel }}</label>
                    </div>

                    <input class="dynamicInput dynamicField"
                           [formControlName]="myControlName"
                           [id]="id"
                           [ngClass]="{'inputDisabled': isDisabled(myPath)}"
                           (focus)="focusFunction($event, field.label, myPath)"
                           (blur)="blurFunction($event)">
                </div>
        <div *ngSwitchCase="'hidden'">
          <input type="hidden" [formControlName]="myControlName" [id]="id" />
        </div>

                <div *ngSwitchDefault>
                    <input class="dynamicInput dynamicField"
                           [formControlName]="myControlName"
                           [id]="id"
                           [ngClass]="{'inputDisabled': isDisabled(myPath)}"
                           (focus)="focusFunction($event, field.label, myPath)"
                           [placeholder]="field.placeholder"
                           (blur)="blurFunction($event)">
                </div>
            </ng-container>
        </ng-container>
    </ng-template>
    <ng-template #validators let-formControlErrors="errors" let-myControlName="myControlName">
        <div class="validationFaild">
            <div *ngFor="let error of formControlErrors | keyvalue">

                <span class="fa fa-exclamation-circle"></span>
                <span [id]="'validationField-' + myControlName">
                    {{error.value}}
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template #addKeyValueBtn let-path="path">
        <div class="addBtnContainer" (click)="addKeyValue(path)">
            <span class="addIcon">
                <img class="action-img" src='../../../../../assets/svg/addIcon.svg' />
            </span>
            <span class="addLabel">
                Add New {{layout[getName(path)]?.label}}
            </span>
        </div>
    </ng-template>
    <ng-template #addKeyObjectBtn let-path="path">
        <div class="addBtnContainer" (click)="addKeyObject(path)">
            <span class="addIcon">
                <img class="action-img" src='../../../../../assets/svg/addIcon.svg' />
            </span>
            <span class="addLabel">
                Add New {{layout[getName(path)]?.label}}
            </span>
        </div>
    </ng-template>

    <ng-template #addValueBtn let-path="path">
        <div class="addBtnContainer" (click)="addValue(path)">
            <span class="addIcon">
                <img class="action-img" src='../../../../../assets/svg/addIcon.svg' />
            </span>
            <span class="addLabel">
                Add New {{layout[getName(path)]?.attributes['header']}}
            </span>
        </div>
    </ng-template>
  <app-analytics-settings class="analytics-settings-container"
          [stepAnalyticsSettings]="analyticsSettings"
          (updateSettings)="updateAnalyticsSettings($event)"
          (close)="onCloseCustomMsgSlider()"
          [isDisabled]="!canEditState"
          #analyticsSlider></app-analytics-settings>
    <app-whats-app-settings
            class="analytics-settings-container"
            *ngIf="supported_channel === 'whatsapp' || supported_channel === 'all'"
            [step]="stepJson"
            (close)="closeWaOverlay()"
            (update)="updateWaSettings($event)"
            [isDisabled]="canEditState"
            #whatsAppSettings>Settings
    </app-whats-app-settings>
</div>

<div *ngIf="isLeftVisible===false">
    <div class="footer">
        <div *ngIf="canEditState && stepTitle !== 'start'" matTooltip="Delete node" matTooltipPosition="above"
             overflowTooltip (click)="openDeleteParentNodeDialog()" class="delete-btn"></div>
        <div *ngIf="stepTitle !== 'start'" matTooltip="Track node" matTooltipPosition="above"
             overflowTooltip (click)="openAnalyticsOverlayOnNode()" class="analytics-btn"></div>
        <div *ngIf="supported_channel === 'whatsapp' || supported_channel === 'all'"
             class="wa-btn" matTooltipClass="matTooltip" matTooltip="WhatsApp settings"
             matTooltipPosition="above"
             (click)="openWaOverlay()"></div>
        <button id="resetNode" [disabled]="typeName === 'chat2pay' && chat2PayHasError" class="close-btn" [ngClass]="{'right-margin': isCurrentEnvProd}" (click)="emitResetNode()">Close</button>
        <ng-container *ngIf="(canEditMenuTextOnly() && nodeType === 'menu') || canEditState">
    <button id="saveNode" [disabled]="typeName === 'chat2pay' && chat2PayHasError" (click)="saveNodeClicked()"
            class="save-btn">Save</button>
  </ng-container>
    </div>
</div>

<div *ngIf="loadingInProgress" class="loading-in-progress">
    <loading-icon></loading-icon>
</div>

<ng-template
  #formArrayDeleteBtn
  let-path="path"
  let-controlName="controlName"
  let-myClass="myClass"
  let-index="index"
>
  <!-- <ng-container *ngIf="getAttributeValue(myControlName,ADD_ATTRIBUTE) && canEditFlows()"> -->
  <div class="{{ myClass }}" (click)="removeFormArray(path, controlName, index)"></div>
</ng-template>

<ng-template
  #formControlDeleteBtn
  let-path="path"
  let-controlName="controlName"
  let-myClass="myClass"
  let-index="index"
>
  <!-- <ng-container *ngIf="getAttributeValue(myControlName,ADD_ATTRIBUTE) && canEditFlows()"> -->
  <div class="{{ myClass }}" (click)="removeFormControl(path, controlName, index)"></div>
</ng-template>

<ng-template #deleteParentNodeDialog>
  <div class="delete_parentNode_dialog">
    <div class="delete_parentNode_dialog_header">
      <label class="delete_parentNode_dialog_title">Deleting parent node</label>
      <button class="delete_parentNode_dialog_closeBtn" (click)="closeModal()">
        <img src='../../../../../assets/svg/close.svg'/>
      </button>
    </div>
    <div class="delete_parentNode_dialog_body">
      <div>
        This is a parent node. Deleting this parent node will also delete all
        <label class="delete_parentNode_dialog_childNode">{{ childCount }}</label> child nodes.
        <div class="delete_parentNode_dialog_checkBoxMessage">
          Do you want to proceed with deleting?
        </div>
      </div>
      <div class="delete_parentNode_dialog_checkBox">
        <mat-checkbox id="check" class="parentCheckBox" (change)="setDisplay($event)">
          <span class="delete_parentNode_dialog_checkBox_label"
            >Don't show this message again.</span
          >
        </mat-checkbox>
      </div>
    </div>
    <div class="delete_parentNode_dialog_buttonsContainer">
      <button class="delete_parentNode_dialog_exitBtn" (click)="closeModal()">Cancel</button>
      <button class="delete_parentNode_dialog_deleteBtn" (click)="deleteNodeClicked()">
        Delete
      </button>
    </div>
  </div>
</ng-template>

<ng-template #icons let-icon="icon">
  <div class="typeImage" [ngStyle]="{'background': 'url(' + icon + ') no-repeat center/100%'}"></div>
</ng-template>


